<template>
	<div class="con">
		<div class="head">
			<div class="head-bot">
				<van-tabs v-model="headActive" @change='headOnChange' color="#27bec4">
					<van-tab title="在院"></van-tab>
					<van-tab title="出院"></van-tab>
				</van-tabs>
			</div>
		</div>
		<div class="list" v-if="noImgShow == false">
			<div v-for="(item,index) in list" class="list-con">
				<div class="list-name">{{item.BRXM}}</div>
				<div>就诊科室：{{item.KSMC}}</div>
				<div>主管医生：{{item.ZZYS}}</div>
				<div>主管护士：{{item.ZGHS}}</div>
				<div>病人性质：{{item.BRXZ}}</div>
				<div class="list-time">
					<div>{{item.RYRQ}}</div>
					~
					<div>{{item.CYRQ}}</div>
				</div>
				<div>疾病名称：{{item.ZDMC}}</div>
				<div class="queryBtn" @click="QueryBtn(index)">
					<van-icon name="share" size='20' />
					<div>费用清单</div>
				</div>
				<div>
					<div class="inspection" @click="InspeBtn(index)">检查检验清单</div>
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无信息~~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'inpatientInfo',
		data() {
			return {
				msg: '住院服务',
				list: [],
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
				headActive: 0,
				navList: [{
						id: 0,
						text: "住院清单",
						img: require('../assets/inHospital.png'),
						to: '/inpatientDeta'
					},
					{
						id: 1,
						text: "住院信息",
						img: require('../assets/inHospital.png'),
						to: '/inpatientDeta'
					},
					{
						id: 2,
						text: "住院缴费",
						img: require('../assets/payCost.png'),
						to: '/inpatientPayCost'
					},
				],
				noImgShow: false,
			}
		},
		methods: {
			//住院清单
			GetInpatient() {
				this.$store.commit('Load', true)
				this.noImgShow = false;
				let stanum = this.headActive + 1;
				//				this.$Axios.Get('/inpatient? + '&status=' + stanum, null).then(data => {
				this.$Axios.Get('/inpatient/inpatient?name='+this.cardUserInfo.name+'&sfzh='+this.cardUserInfo.sfzh+'&status=' + stanum, null).then(data => {
					console.log(data)
					this.$store.commit('Load', false)
					if(data.code == 0) {
						if(data.msg.length != 0) {
							this.list = data.msg;
							this.noImgShow = false;
						} else {
							this.noImgShow = true;
						}

					} else {
						this.list = '';
						this.noImgShow = true;
					}
				}).catch(err => {
					this.$toast("网络未连接")
					this.$store.commit('Load', false)
					this.noImgShow = true;
					console.log(err)
				})
			},
			//导航
			headOnChange(event) {
				this.headActive = event;
				this.GetInpatient();
			},
			//查询
			QueryBtn(e) {
				console.log(this.list[e].ZYH)
				this.$router.push({
					path: '/inpatientDeta',
					query: {
						id: this.list[e].ZYH
						
					}
				})
			},
			dro() {
				this.GetInpatient();
			},
			//检验清单
			InspeBtn(e) {
				console.log(this.list[e].ZYH)
				let startDate = this.formatDate(this.list[e].RYRQ)
				this.$router.push({
					path: '/report',
					query: {
						brid: this.list[e].ZYHM,
						type: 2,//2、住院 1、门诊
						startDate:this.formatDate(this.list[e].RYRQ),
						endDate: this.formatDate(this.list[e].CYRQ)
					}
				})
			},
			formatDate(date) {
				const date1 = new Date(date)
      			return `${date1.getFullYear()}-${date1.getMonth() + 1}-${date1.getDate()}`;
    		},

		},
		mounted() {
			console.log(this.cardUserInfo)
			this.GetInpatient()
		},
		created() {},
	}
</script>

<style scoped>
	.head {
		padding: 0 0 10px 0;
		position: relative;
		font-size: 15px;
	}
	
	.card {
		padding: 30px 20px;
		margin: 10px auto;
		position: relative;
		width: 80%;
		background-color: #fff;
		border: 1px solid #27BEC4;
		box-shadow: 2px 2px 2px #27BEC4;
		font-size: 16px;
		overflow: hidden;
	}
	
	.ca-di {
		padding: 10px;
		display: flex;
		align-items: center;
		border: 1px solid #27BEC4;
		width: 100px;
		border-radius: 5px;
	}
	
	.card-text {
		width: 60%;
	}
	
	.card img {
		position: absolute;
		right: 0;
		top: 0;
		width: 150px;
		height: 170px;
	}
	
	.nav-list {
		padding: 10px 0;
		display: flex;
		justify-content: space-around;
		background-color: #fff;
		font-size: 15px;
	}
	
	.nav-big {
		text-align: center;
	}
	
	.nav-big img {
		width: 50px;
		height: 50px;
	}
	
	.list {
		flex: 1;
		overflow-y: auto;
		background-color: #FFFFFF;
	}
	
	.list-con {
		position: relative;
		margin: 10px 20px;
		padding: 5px;
		border-bottom: 1px solid #ccc;
		font-size: 15px;
	}
	
	.list-con div {
		margin-bottom: 10px;
	}
	
	.list-name {
		padding: 5px;
		border-left: 5px solid #27BEC4;
		font-weight: 700;
	}
	
	.list-time {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		color: #999;
	}
	
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	.queryBtn {
		position: absolute;
		right: 0;
		top: 10px;
		text-align: center;
		color: #27BEC4;
		font-size: 12px;
	}
	
	.inspection {
		display: inline;
		padding: 5px 10px;
		border-radius: 5px;
		background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
		color: #fff;
	}
</style>